import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { Loader2Icon } from 'lucide-react';
import { useEffect } from 'react';
import { AppShell } from '@/components/layout/app-shell';
import { ErrorBoundary } from '@/components/states';
import { useAuth } from '@/lib/auth/context';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
});

/**
 * Gerbang seluruh layar internal (T-P7-06).
 *
 * Penjagaan dilakukan saat render, bukan `beforeLoad`: status sesi baru diketahui
 * setelah IndexedDB dibaca, dan `beforeLoad` akan memutuskan sebelum jawabannya
 * ada — memantulkan collector yang sebenarnya masih punya sesi sah ke layar login.
 */
function AppLayout() {
  const { status, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'locked') void navigate({ to: '/kunci', replace: true });
    if (status === 'anonymous' || status === 'expired') {
      void navigate({ to: '/masuk', replace: true });
    }
  }, [status, navigate]);

  if (status !== 'authenticated' || !user) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Loader2Icon className="size-6 animate-spin text-muted-foreground" aria-hidden="true" />
        <span className="sr-only">Memuat sesi…</span>
      </div>
    );
  }

  return (
    <AppShell>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </AppShell>
  );
}
